import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useState } from "react";
import { DeleteModal } from "..";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useParcels } from "../../store/useParcels";

dayjs.extend(relativeTime);

export const CourierParcelTable = () => {
  /** Hooks */
  const { allParcels, deleteParcel } = useParcels();
  const navigate = useNavigate();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Courier
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Volume
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Revenue
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Location
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {allParcels?.map((item) => {
            return (
              <tr
                key={item._id}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td
                  onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap text-xs sm:text-base"
                >
                  {/* @ts-ignore */}
                  {item?.courier?.name}
                </td>
                <td
                  onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base"
                >
                  {item?.volume}
                </td>
                <td
                  onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base"
                >
                  {Number(item.revenue ? item.revenue / 100 : 0)?.toFixed(2)}€
                </td>
                <td
                  onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {/* @ts-ignore */}
                  {item?.location?.cost_place}
                </td>
                <td
                  onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {dayjs(item?.date).format("MMM YYYY")}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                  <EditIcon
                    onClick={() => navigate(`/edit-parcel/${item?._id}`)}
                    className="mr-3 sm:mr-7"
                  />
                  <TrashIcon
                    onClick={() => {
                      const confirmDelete = window.confirm(
                        "Are you sure you want to delete this Parcel?"
                      );
                      if (confirmDelete) {
                        deleteParcel(item._id as string);
                      }
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
